import { schema } from 'normalizr'

// Schemas
import { artistListSchema } from 'modules/artists/models'
import { collectionListSchema } from 'modules/collections/models'
import { labelListSchema } from 'modules/labels/models'
import { trackList } from 'normalize'

// Types
import type { Song, Collection } from 'types'

export type CmsBlock = {
  readonly id: string
  readonly type: string
  readonly value: {
    loggedin_required: 0 | 1
    perks?: Array<{ text: string }>
    title?: string
    questions?: Array<{
      question: string
      answer: string
    }>
    hero_articles?: Array<{
      article: number
    }>
  }
}

export type CmsPageCategory = {
  readonly id: number
  readonly name: string
  readonly slug: string
  readonly color: string
}

export type CmsPage = {
  readonly hide_nav?: boolean
  readonly author: {
    id: number
    alias: string
  }
  readonly categories: Array<CmsPageCategory>
  readonly content: Array<CmsBlock>
  readonly entities: {
    songs: Array<Song>
    collections: Array<Collection>
  }
  readonly hide_comments: boolean
  readonly hide: boolean
  readonly id: number
  readonly image_only_hero: boolean
  readonly video_only_hero_mp4: {
    id: number
  }
  readonly video_only_hero_webm: {
    id: number
  }
  readonly video_only_hero_mobile_mp4: {
    id: number
  }
  readonly video_only_hero_mobile_webm: {
    id: number
  }

  readonly image: {
    id: number
  }
  readonly introduction: string
  readonly meta: {
    parent: CmsPage
    first_published_at: string
    seo_title: string
    slug: string
    type: string
  }
  readonly mobile_override_image: {
    id: number
  }
  readonly sidebar_content: Array<unknown>
  readonly sharing_image: {
    id: number
  }
  readonly summary: string
  readonly title_max_length: number
  readonly title: string
  readonly video: string
  readonly theme: string
}

const subEntities = {
  entities: {
    tracks: trackList,
    collections: collectionListSchema,
    labels: labelListSchema,
    artists: artistListSchema,
  },
}

export const pageSchema = new schema.Entity('pages', subEntities)
export const pageListSchema = [pageSchema]

export const pageSummarySchema = new schema.Entity('pageSummaries', subEntities)
export const pageSummaryListSchema = [pageSummarySchema]

export type ButtonBlock = {
  text: string
  url: string
  show_for: 'all' | 'logged_in' | 'logged_out'
}
